export const Items: {[k: string]: ModdedItemData} = {
	apicotberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	custapberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	ganlonberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	jabocaberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	liechiberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	micleberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	petayaberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	rowapberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	salacberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	souldew: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
};
